import { AppModule } from '../app.module';
import { Injectable, ElementRef, ViewChild } from '@angular/core';

import { Toast, ToasterModule, ToasterService } from 'angular2-toaster';
import { FileSelectDirective, FileUploader } from 'ng2-file-upload/ng2-file-upload';

import { SmsPageComponent } from '../pages/sms-page/sms-page.component';
import { AirportWebService } from '../airport-web-service//airport-web-service';
import { BaseResult } from '../base-result';



@Injectable() 
export class DesktopService { 

  name: string = 'DesktopService';
  hasImage: boolean = false;

  pictureData: string;
  desktopFileUpload:  string;  // the file name returned by the desktop file upload process - used to show thumbnail on
                               // desktop and also attach the phone to the submitted incident
  directory: string;
  fileName: string;
  fileURI: string;

  smsPage: SmsPageComponent;

  @ViewChild('fileUploadComponent')
  private fileUploadComponent: FileUploader;

  filesToUpload: Array<File>;

  constructor( private airportws: AirportWebService, private alertController: ToasterService  ) { }
  // constructor( private camera: Camera, private file: File, private alertController: AlertController, private airportws: AirportWebService ) { }

  getPictureFromDesktop(service: DesktopService, smsPage: SmsPageComponent, event: Event): void {
    console.log('getPictureFromDesktop event: ' + JSON.stringify(event));
    //console.log('getPictureFromDesktop smsPage: ' + JSON.stringify(smsPage));
    //console.log('getPictureFromDesktop service: ' + JSON.stringify(service));


    this.smsPage = smsPage;
    let files = null;
    if (event.target != null) {
      console.log(JSON.stringify(event.target));
      console.log(event.target['files']);
      files = event.target['files'];
    } else if (event.srcElement != null) {
      console.log(JSON.stringify(event.srcElement));
      console.log(event.srcElement['files']);
       files = event.srcElement['files'];
    }

    this.filesToUpload = files;

    console.log('filesToUpload: ' + JSON.stringify(this.filesToUpload));

    let jsonResult: BaseResult;

    this.makeFileRequest(this.airportws.baseURL + '/saveFileData', [], this.filesToUpload).then((result) => {
            console.log('makeFileRequest: ' + JSON.stringify(result));
            jsonResult = result as BaseResult;

            this.smsPage.handleFileUploadResult(jsonResult);
        }, (error) => {

          console.error(error);

        const toast: Toast = {
            type: 'error',
            title: 'Picture upload failed',
            body: 'Unable to upload picture [server error]',
            showCloseButton: false,
            closeHtml: ''
        };

        const alert = this.alertController.pop( toast );
    });


  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    
          console.log('Entering makeFileRequest');
    
          return new Promise((resolve, reject) => {
          
            const formData: any = new FormData();
          
            const xhr = new XMLHttpRequest();
          
            for (let i = 0; i < files.length; i++) {
                formData.append('uploads[]', files[i], files[i]['name']);
                console.log('Appended file: ' + files[i]['name']);
            }
          
            xhr.onreadystatechange = function () {
              
                console.log('xhr.onreadystatechange function, readystate: ' + xhr.readyState);
                console.log('xhr.onreadystatechange function, status: ' + xhr.status);
              
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        const fileUploadResult: BaseResult = JSON.parse(xhr.response);
                        console.log('xhr.onreadystatechange function, good xhr.response: ' + JSON.stringify(xhr.response));
                        resolve( fileUploadResult );
                    } else {
                        console.log('xhr.onreadystatechange function, bad xhr.response: ' + JSON.stringify(xhr.response));
                        reject(xhr.response);
                    }
                }
            };

            console.log('About to POST to: ' + url);
            xhr.open('POST', url, true);
           // xhr.setRequestHeader('Content-Type', 'multipart/form-data');
            xhr.send(formData);
        });
    }

  pictureSuccess(fileURI: string, service: DesktopService): void {

    console.log('pictureSuccess - fileURI: ' + fileURI);
    service.fileURI = fileURI;

    service.directory = fileURI.substring(0, fileURI.lastIndexOf('/') + 1 );
    console.log('pictureSuccess - directory: ' + service.directory);

    service.fileName = fileURI.substring(fileURI.lastIndexOf('/') + 1 );
    console.log('pictureSuccess - fileName: ' + service.fileName);

    if (service.fileName.indexOf('?') > -1) {
      service.fileName = service.fileName.substring(0, service.fileName.indexOf('?'));
      console.log('removed weird bogus parameter from fileName: ' + service.fileName);
    }

    service.readFile(service);
  }

  readFile(service: DesktopService): void {

    console.log('readFile - about to read file ');



//    service.file.readAsDataURL(service.directory, service.fileName).then(
//        function(base64String){ service.setPictureData(base64String, service); },
//        function(err){ service.pictureError(err, service); }
//    );
  }

  setPictureData(data: string, service: DesktopService) {
      console.log('setPictureData: ' + data.substring(0, 30) + '...' + data.substring(data.length - 30));

      service.hasImage = true;
      service.pictureData = data;

      this.smsPage.setThumbnailLocation(this.fileURI);

//      let alert = service.alertController.create({ title: service.name, subTitle: "Success", message: "Uploading picture...", buttons: ['OK'], cssClass: "errorAlert" });
//      alert.present();
  }

  pictureError(err: any, service: DesktopService): void {
    service.hasImage = false;

    if (err.code === undefined ) {
      // do nothing
    } else {
      console.log('error attempting to use picture');
      console.log('err: ' + err.code);
      console.log('err: ' + err.message);



      const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'Unable to attach picture [' + err.code + ': ' + err.message + ']',
          showCloseButton: false,
          closeHtml: ''
      };

      const alert = this.alertController.pop( toast );
//      const alert = service.alertController.create({ title: 'Error', subTitle: "Unable to attach picture", message: err.code + ": " + err.message, buttons: ['OK'], cssClass: "errorAlert" });
//      alert.present();
    }
  }


}
